import Swiper from '../_libs/swiper.esm.browser.bundle'; // quiet

export default class ResourcesFocusArea {


	// Constructor
	constructor(element) {

		this.buttonClick = this.buttonClick.bind(this);
		this.slideChange = this.slideChange.bind(this);
		this.videoButtonClick = this.videoButtonClick.bind(this);

		this.videoContainer = element.querySelector('.section-resources-focus-area--videos')

		this.handleVideoState = this.handleVideoState.bind(this)

		this.videos = Array.prototype.slice.call(this.videoContainer.querySelectorAll('video'), 0)

		this.videos.forEach((video) => {
			video.addEventListener('play', this.handleVideoState)
			video.addEventListener('ended', this.handleVideoState)
			video.addEventListener('pause', this.handleVideoState)
		})

		this.buttonContainer = element.querySelector('.section-resources-focus-area--buttons');
		this.buttonNext = element.querySelector('.paged-buttons--next');
		this.buttonPrev = element.querySelector('.paged-buttons--prev');

		this.numberCurrent = element.querySelector('.paged-buttons--total strong');
		this.numberTotal = element.querySelector('.paged-buttons--total span');

		this.buttons = Array.prototype.slice.call(element.querySelectorAll('.section-resources-focus-area--video button'), 0);
		this.videos = Array.prototype.slice.call(element.querySelectorAll('.section-resources-focus-area--video video'), 0);
		for (var i=0, l=this.buttons.length; i<l; i++) {
			this.buttons[i].addEventListener('click', this.videoButtonClick);
		}

		this.buttonNext.addEventListener('click', this.buttonClick);
		this.buttonPrev.addEventListener('click', this.buttonClick);


		this.swiper = new Swiper(element.querySelector('.swiper-container'), {
			grabCursor: true,
			loop: false,
			slidesOffsetBefore: 0,
			slidesPerView: 1,
			slideToClickedSlide: false,
			spaceBetween: 0,
			threshold: 1,
			on: {
				slideChange: this.slideChange
			}
		});

		this.slideChange();

		if (this.videos.length <= 1) {
			this.buttonContainer.style.display = 'none';
		}

	}

	handleVideoState(e) {
		if (e.type == 'play') {
			e.currentTarget.parentNode.querySelector('button').style.display = 'none'
			this.videoContainer.classList.add('playing')
			return;
		}

		e.currentTarget.parentNode.querySelector('button').style.display = 'block'
		this.videoContainer.classList.remove('playing')
	}

	// Event Handlers
	buttonClick(event) {
		event.preventDefault();
		if (event.currentTarget === this.buttonPrev) {
			this.swiper.slidePrev();
		} else {
			this.swiper.slideNext();
		}
	}
	slideChange() {
		const page = this.swiper.realIndex;
		const total = this.videos.length;

		this.videos.forEach((video) => {
			video.pause();
		});

		this.buttonNext.classList.remove('is-disabled');
		this.buttonPrev.classList.remove('is-disabled');
		if (page === total - 1) {
			this.buttonNext.classList.add('is-disabled');
		}
		if (page === 0) {
			this.buttonPrev.classList.add('is-disabled');
		}

		this.numberCurrent.innerHTML = this.displayNumber(page + 1);
		this.numberTotal.innerHTML = this.displayNumber(total);
	}
	videoButtonClick(event) {
		event.preventDefault();
		const index = this.buttons.indexOf(event.currentTarget);
		this.videos[index].classList.add('is-playing');
		this.videos[index].play();
	}

	// Helpers
	displayNumber(number) {
		if (number < 10) {
			return '0' + number;
		}
		return number;
	}


}
